import { render, staticRenderFns } from "./CallDashboard.vue?vue&type=template&id=fab3aea4&"
import script from "./CallDashboard.vue?vue&type=script&lang=js&"
export * from "./CallDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CallDashboard.vue?vue&type=style&index=0&id=fab3aea4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports